import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ShiftResource, shiftsGetShiftsForCalendarWeek } from '~/generated';
import { extractData } from '~/utils/query-utils';

const EXPAND = ['turns', 'applications', 'applications.publisher'] as const;

export const useShiftsForCalendarWeek = (args: {
  year: number;
  week: number;
  options?: Omit<
    UseQueryOptions<ShiftResource[], Error>,
    'queryFn' | 'queryKey'
  >;
}) =>
  useQuery({
    ...args.options,
    queryFn: () =>
      extractData(
        shiftsGetShiftsForCalendarWeek({
          path: { calendarYear: args.year, calendarWeek: args.week },
          query: { expand: [...EXPAND] },
        })
      ),
    queryKey: ['shifts', args.year, args.week, EXPAND],
  });
